import { render, staticRenderFns } from "./TheGameGalleryFeature.vue?vue&type=template&id=4a1b2145"
import script from "./TheGameGalleryFeature.vue?vue&type=script&lang=js"
export * from "./TheGameGalleryFeature.vue?vue&type=script&lang=js"
import style0 from "./TheGameGalleryFeature.vue?vue&type=style&index=0&id=4a1b2145&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports